import { FC } from "react";

import { Trans, useTranslation } from "react-i18next";

import { Checkbox } from "@mantine/core";
import { InputProps } from "@utils/InputProps.util";
import { ISubmissionConditions } from "@models/SubmissionConditions.model";
import { Draft } from "@utils/Draft.util";

export const SubmissionConditionsInput: FC<
  InputProps<Draft<ISubmissionConditions>> & {
    showTermsAndConditions?: boolean;
  }
> = ({ conditionsAccepted, showTermsAndConditions = true }) => {
  const { t } = useTranslation();
  return (
    <Checkbox.Group orientation="vertical" {...conditionsAccepted}>
      <Checkbox
        required
        label={
          <Trans
            i18nKey={"forms.submissionConditions.privacyPolicy"}
            // eslint-disable-next-line jsx-a11y/anchor-has-content, jsx-a11y/anchor-is-valid
            components={{ linkTag: <a /> }}
          ></Trans>
        }
        value="privaryPolicyAccepted"
      />
      {showTermsAndConditions && (
        <Checkbox
          required
          label={t("Terms and conditions accepted")}
          value="conditionsOfParticipationAccepted"
        />
      )}
      <Checkbox
        label={t("We may store your data for future events")}
        value="saveDataForFutureEventsAccepted"
      />
    </Checkbox.Group>
  );
};
